package com.dotdrives.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class GiverSummary(
    val id: String,
    @SerialName("display_name")
    val displayName: String,
    @SerialName("giver_type")
    val giverType: String,
    @SerialName("steward_user_id")
    val stewardUserId: String?,
    val stewardName: String?,
    val temperature: String,
    val tags: List<String>,
    val lifetime: Double? = null,
    val yearTotal: Double? = null,
    val lastGiftAt: Instant? = null,
    val isActive: Boolean = true,
)

@Serializable
data class Giver(
    val id: String,
    @SerialName("org_id")
    val orgId: String,
    @SerialName("giver_type")
    val giverType: String,
    @SerialName("first_name")
    val firstName: String?,
    @SerialName("last_name")
    val lastName: String?,
    @SerialName("display_name")
    val displayName: String,
    @SerialName("spouse_name")
    val spouseName: String?,
    val email: String?,
    val phone: String?,
    val address: String?,
    @SerialName("steward_user_id")
    val stewardUserId: String?,
    val temperature: String,
    val tags: List<String>,
    @SerialName("created_at")
    val createdAt: Instant,
    @SerialName("updated_at")
    val updatedAt: Instant,
    @SerialName("legacy_is_active")
    val isActive: Boolean = true,
)

data class NewGiver(
    val giverType: String,
    val firstName: String,
    val lastName: String,
    val displayName: String,
    val spouseName: String?,
    val email: String?,
    val phone: String?,
    val address: String?,
    val stewardUserId: String?,
    val tags: List<String>,
)
